import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const BodyWrapper = styled.span`
  margin-left: 10px;
  background: ${(props) =>
    props.isColumnFiltered ? "rgb(0, 69, 118)" : "white"};
  box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
  border-radius: 50%;
  padding: 1px 4px;
`;

const FilterButtonForTableHeader = ({ handleOnClick, isColumnFiltered }) => {
  return (
    <BodyWrapper onClick={handleOnClick} isColumnFiltered={isColumnFiltered}>
      <FontAwesomeIcon
        icon={faChevronDown}
        style={{ fontSize: 10, color: isColumnFiltered && "white" }}
      />
    </BodyWrapper>
  );
};

//rgb(0, 69, 118)

export default FilterButtonForTableHeader;
